import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import instagram from './images/replaceME.jpg';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Point O' Woods"
      meta={[
        {
          name: 'description',
          content:
            'A secluded and exclusive oasis on Fire Island with limited access providing serentiy unlike anywhere elese.',
        },
        {
          name: 'keywords',
          content:
            "Point O' Woods, Fire Island, Ferries, New York, Long Island, Water Taxi",
        },
      ]}
    />
    <Navigation />
    <div className='container p-0'>
      <PageHeader beach="Point O' Woods">
        <h2>Communities</h2>
        <h1>Point O' Woods</h1>
        <p>Amenities</p>
        <div className='amenities'>
          {Amenities.byBeach("Point O' Woods").map((item) => (
            <i
              key={item.text}
              className={`icon-${item.icon}`}
              title={item.text}
            />
          ))}
        </div>
        <div>
          <Link className='btn btn-outline-light' to='/directory'>
            Directory
          </Link>
        </div>
      </PageHeader>
    </div>
    <div className='container page'>
      <div className='row'>
        <div className='col-xl'>
          <div className='heading'>
            <h1>About Point O' Woods</h1>
          </div>
          <p>
            Point O’ Woods is one of the oldest and most exclusive communities
            on Fire Island. The community maintains its own ferry service for
            residents and their guests to use during the spring, summer, and
            fall. This community remains untarnished by time with its old lamp
            post, winding walkways, and stunning cedar shake homes seemingly
            straight out of an architecture magazine. This family-oriented
            community maintains a private club house for their residents, as
            well as a post office, and grocery store.
          </p>
        </div>
        {/* <div className="col-xl-4">
          <Instagram account="fiferries" datestamp="June 23, 2016" profile={fiferries} image={instagram} link="https://www.instagram.com/fiferries" className="mx-auto" />
        </div> */}
      </div>
      <Tip title="Captain's Tip">
        The Point O’ Woods ferry is located across the street just before Fire
        Island Ferries’ main terminal driveway.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Point O' Woods is provided by private ferry
        service.
      </p>
      <p>
        <a href='http://www.fireislandwatertaxi.com'>Water Taxi</a> service is
        available to and from Point O' Woods during in-season operation for
        residents and their guests.
      </p>
      <Island />
    </div>
  </div>
);
